import { Feature } from './types';

export const getAllFeatures = () => {
  const allFeatures: Feature[] = [];

  for (const permission in Feature) {
    const feature = Feature[permission] as any;

    if (!permission.includes('EDIT_VIEW_ONLY')) {
      allFeatures.push(feature);
    }
  }

  return allFeatures;
};

const readOnlyExcludedFeatures: Feature[] = [
  Feature.USER_MANAGEMENT_VIEW,
  Feature.OFFERS_VIEW,
  Feature.OFFER_VIEW,
  // PII feature — not for broad read-only roles
  Feature.RETAILER_NETWORK_USER_MOBILE_PHONE_VIEW,
];

const isViewOrEditViewOnlyPermission = (permission: string) =>
  permission.includes('VIEW') || permission.includes('EDIT_VIEW_ONLY');

export const getAllReadOnlyFeatures = () => {
  const allReadOnlyFeatures: Feature[] = [];

  for (const permission in Feature) {
    const feature = Feature[permission] as any;

    if (isViewOrEditViewOnlyPermission(permission) && !readOnlyExcludedFeatures.includes(feature)) {
      allReadOnlyFeatures.push(feature);
    }
  }

  return allReadOnlyFeatures;
};
